import { render, staticRenderFns } from "./ResourcePlanning.vue?vue&type=template&id=73395ac9&scoped=true&"
import script from "./ResourcePlanning.vue?vue&type=script&lang=js&"
export * from "./ResourcePlanning.vue?vue&type=script&lang=js&"
import style0 from "./ResourcePlanning.vue?vue&type=style&index=0&id=73395ac9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73395ac9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/project/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VFlex,VLayout})
